import Vue from 'vue';

export const ShortcutMixin = Vue.extend({
	mounted() {
		window.addEventListener('keydown', this.keyboardShortcutsHandler);
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.keyboardShortcutsHandler);
	},
	methods: {
		keyboardShortcutsHandler() {},
	},
});
